module.exports = __webpack_public_path__ + "static/img/icon-step3-on.f71b5303.png";